export default __webpack_public_path__ + "static/media/support1.16776896.jpg";